<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">
          {{ isEdit ? "Edit Dynamic Route" : "Create Dynamic Route" }}
        </h3>
      </v-flex>

      <v-flex class="pa-0" xs12>
        <v-card>
          <v-card-text class="px-6 py-4">
            <v-form ref="createForm" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex md4 xs12 class="mr-4">
                  <v-select
                      :items="Types"
                      item-text="name"
                      item-value="value"
                      label="Status *"
                      outlined
                      v-model="formData.type"
                      :rules="[rules.required]"
                  ></v-select>
                </v-flex>

                <v-flex class="pr-2" md6 xs12>
                  <v-text-field
                      :rules="[rules.required]"
                      label="Label *"
                      outlined
                      type="text"
                      v-model="formData.name"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                      :rules="[rules.required]"
                      label="Link of Redirect Routes *"
                      outlined
                      type="text"
                      v-model="formData.path"
                  ></v-text-field>
                </v-flex>

                <v-flex class="d-flex justify-end" xs12>
                  <v-btn
                      :loading="loading"
                      @click="saveModel"
                      color="primary"
                      :disabled="!valid"
                  >
                    Update
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-form>
            <!-- Snackbar -->
            <v-snackbar
                v-model="snackbar.show"
                :color="snackbar.color"
                bottom
                timeout="3000"
                style="margin: 0 auto;"
            >
              {{ snackbar.text }}
            </v-snackbar>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      valid: false,
      loading: false,
      snackbar: {
        show: false,
        text: '',
        color: 'success'
      },
      formData: {
        type: null,
        name: "",
        path: "",
      },
      Types: [
        { value: "new", name: "New" },
        { value: "old", name: "Old" },
      ],
      rules: {
        required: (value) => !!value || "This field is required.",
        validLink: (value) =>
            /^(\/[a-zA-Z0-9-_]+)+$/.test(value) ||
            "Must be a valid route path (e.g., /path or /path/subpath)",
      },
    };
  },

  computed: {
    isEdit() {
      return !!this.$route.params.id;
    },
  },

  async mounted() {
    if (this.isEdit) {
      await this.fetchRouteData();
    }
  },

  methods: {
    async fetchRouteData() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        const res = await axios.get(
            `https://backend.immigration.gov.np/api/v1/dynamic_routes/${id}`
        );

        const route = res.data.data;
        this.formData = {
          type: route.route_type,
          name: route.route_name,
          path: route.route_url,
        };
      } catch (error) {
        console.error("Failed to load data:", error);
        this.snackbar = {
          show: true,
          text: "Failed to load route details.",
          color: "error",
        };
      } finally {
        this.loading = false;
      }
    },

    async saveModel() {
      if (!this.$refs.createForm.validate()) return;

      this.loading = true;
      const payload = {
        route_type: this.formData.type,
        route_name: this.formData.name,
        route_url: this.formData.path,
      };

      try {
        if (this.isEdit) {
          // Update existing record
          const id = this.$route.params.id;
          await axios.put(
              `https://backend.immigration.gov.np/api/v1/dynamic_routes/${id}`,
              payload
          );
          this.snackbar = {
            show: true,
            text: "Dynamic route updated successfully!",
            color: "success",
          };
        } else {
          await axios.post(
              "https://backend.immigration.gov.np/api/v1/dynamic_routes",
              payload
          );
          this.snackbar = {
            show: true,
            text: "Dynamic route created successfully!",
            color: "success",
          };
        }

        // Redirect to the named route instead of hardcoded path
        this.$router.push({ name: 'DynamicRoutes' });

      } catch (error) {
        console.error(error);
        const message =
            (error.response && error.response.data && error.response.data.message) ||
            "Failed to save dynamic route.";

        this.snackbar = {
          show: true,
          text: message,
          color: "error",
        };
      } finally {
        this.loading = false;
      }
    }

  },
};
</script>